import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { Container } from "react-bootstrap";
import List from "./List";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { allUserList, approveOrRejectUser, reqToChangePassword } from "../../redux/slice/userSlice";
import { useLoader } from "../../context/LoaderContext";
import PasswordChangeModal from "../../components/modals/PasswordChangeModal";
import { useToast } from "../../context/TostContext";

const OtpMessage = () => {
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const toast = useToast();
  // Pagination
  const [
    limit,
    setLimit
  ] = useState({ value: 10, label: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  // Open Add User Modal
  // Open ChangePassword Modal
  const [openChangePwModal, setOpenChangePwModal] = useState(false);
  const [changePasswordId, setChangePasswordId] = useState("");
  // Toggle Dropdown
  const [openDropdown, setOpenDropdown] = useState(null);
  // Card Status
  const [cardStatus, setCardStatus] = useState("");
  console.log("sdwdw", setCardStatus);

  // Search Bar
  const [searchTerm, setSearchTerm] = useState("");


  // console.log("cardStatus",cardStatus);

  const { users = [], totalUsers = 0 } = useSelector((state) => state?.user?.allUser?.data || {});

  // Action Dropdown handler
  const handleToggleDropdown = (dropdownId) => {
    setOpenDropdown((prev) => (prev === dropdownId ? null : dropdownId));
  };

  // status handler based on Card Click (APi will get call and display list based on status)
  // const handleCardClick = (value) => {
  //   setCardStatus(value);
  //   setCurrentPage(1);
  // };

  const getCustomerActions = (item) => {
    if (!item || !item.status) {
      return []; // Return an empty array if the item or status is invalid
    }

    const actions = [];

    if (item.status === "pending") {
      // Show both Approve and Reject buttons
      actions.push(
        {
          title: "Approve",
          handler: () => handleUserApproveOrReject("approved", item),
        },
        {
          title: "Reject",
          handler: () => handleUserApproveOrReject("rejected", item),
        }
      );
    } else if (item.status === "approved") {
      // Show only the Reject button
      actions.push({
        title: "Reject",
        handler: () => handleUserApproveOrReject("rejected", item),
      });
    } else if (item.status === "rejected") {
      // Show only the Approve button
      actions.push({
        title: "Approve",
        handler: () => handleUserApproveOrReject("approved", item),
      });
    }

    // Actions always available
    actions.push(
      // {
      //   title: "Deactivate",
      //   handler: () => handleDeactivateUser(item),
      //   style: { color: "red" },
      // },
      {
        title: "Change Password",
        handler: () => handleChangePassword(item),
      }
    );
    return actions;
  };

  const handleChangePassword = (item) => {
    setChangePasswordId(item);
    setOpenChangePwModal(true);
  };

  // const handleDeactivateUser = (item) => {
  //   // console.log("Deactivate:", item);
  //   // Add logic to view the user's profile
  // };

  // Approve or Reject User
  const handleUserApproveOrReject = (type, item) => {
    try {
      const id = item?.id;
      if (type && id) {
        setLoading(true);
        const data = { status: type };
        dispatch(approveOrRejectUser({ data, id })).then((res) => {
          toast.success(res?.payload.message || "User status updated successfully!");
          if (res?.payload?.user) {
            dispatch(allUserList({ status: cardStatus, page: currentPage }));
          }
        });
      } else {
        setLoading(false);
        toast.error("User status or Id Missing!");
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err?.message || "Failed to update user status!";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const searchTimeout = useRef(null);

  // Debounced Search Handler
  const handleSearch = useCallback(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      // console.log("SEARCH API...");  
      dispatch(allUserList({ search: searchTerm, page: currentPage, status: cardStatus, }));
    }, 300); // 300ms delay for better UX
  }, [searchTerm, currentPage, cardStatus, dispatch]);

  // Trigger API Call when search or page changes
  useEffect(() => {
    handleSearch();
    return () => clearTimeout(searchTimeout.current);
  }, [handleSearch]);

  // Api Call for All Users
  const getAllUsersData = useCallback(() => {
    setLoading(true);
    // console.log("MAIN API...");
    dispatch(
      allUserList({
        status: cardStatus,
        page: currentPage,
        limit: limit?.value,
      })
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, cardStatus, limit?.value, currentPage, setLoading]);

  useEffect(() => {
    getAllUsersData();
  }, [getAllUsersData]);

  // Handler for Exporting All Users
  const handleExportAllUsersList = () => {
    try {
      setLoading(true);
      dispatch(allUserList({ search: searchTerm, status: cardStatus, limit: 100000 })).then((res) => {
        const data = res?.payload?.data?.users;
        if (!data || data.length === 0) {
          toast.success("No data available to Export", "success");
          setLoading(false);
          return;
        }

        // Map the data for export
        const dataToExport = data?.map((item) => {
          return {
            Name: item?.profile?.name || "N/A",
            MobileNo: item?.mobile_number || "N/A",
            Email: item?.email || "N/A",
            Designation: item?.profile?.designation || "N/A",
            BankName: item?.profile?.bank?.bank_name || "N/A",
            BranchCity: item?.profile?.branch?.branch_name || "N/A",
            Status: item?.status || "N/A",
            CreatedAt: item?.created_at ? new Date(item.created_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }) : "-",
            UpdatedAt: item?.updated_at ? new Date(item.updated_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }) : "-",
          }
        })

        // Export to Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "All Users");
        const fileName = "All Users(Admin).xlsx";
        XLSX.writeFile(workbook, fileName);
        setLoading(false);
        dispatch(allUserList({ search: searchTerm, status: cardStatus, page: currentPage, limit: limit?.value }))
      })
    } catch (error) {
      console.error("Error exporting data: ", error);
      toast.error("Error exporting data: ", error);
      setLoading(false); // Disable loading state on error
    }
  }

  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(totalUsers / limit?.value) || 1,
    total: totalUsers || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, totalUsers, limit]);

  return (
    <>

      <Container fluid className="px-0">


        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          {/* List Section */}
          <List
            data={users}
            searchTerm={searchTerm}
            openDropdown={openDropdown}
            setCurrentPage={setCurrentPage}
            setSearchTerm={setSearchTerm}
            getCustomerActions={getCustomerActions}
            handleToggleDropdown={handleToggleDropdown}
            handleExportAllUsersList={handleExportAllUsersList}
            pagination={paginationConfig}
          />

          {openChangePwModal && (
            <PasswordChangeModal
              isOpen={openChangePwModal}
              onClose={() => {
                setOpenChangePwModal(false);
                setChangePasswordId("");
              }}
              onSubmit={async (newPassword) => {
                const data = {
                  userId: changePasswordId?.id,
                  newPassword: newPassword,
                };
                await dispatch(reqToChangePassword({ data })).unwrap();
                dispatch(allUserList({ status: cardStatus, page: currentPage, limit: limit?.value }));
              }}
              title="Change Password"
            />
          )}
          {/* Add User Modal */}

        </div>
      </Container>
    </>
  );
};

export default OtpMessage;
